// extracted by mini-css-extract-plugin
export var container = "_9y-0";
export var icon = "_9y-1";
export var text = "_9y-2";